const SvgFiles = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 122 86"
        {...props}
    >
        <rect
            width="57.453"
            height="57.453"
            x=".62"
            y="12.981"
            fill="#F5F5F5"
            rx="6"
            transform="rotate(-13.035 .62 12.981)"
        />
        <g clipPath="url(#a)">
            <path
                fill="#33F"
                d="M43.864 24.602a3.13 3.13 0 1 0-1.413-6.099 3.13 3.13 0 0 0 1.413 6.1Z"
            />
            <path
                fill="url(#b)"
                d="m46.643 10.393-32.528 7.531a4.173 4.173 0 0 0-3.124 5.007l7.53 32.528a4.173 4.173 0 0 0 5.008 3.124l32.527-7.53a4.173 4.173 0 0 0 3.125-5.008L51.65 13.518a4.173 4.173 0 0 0-5.007-3.125Zm.164 22.365a2.088 2.088 0 0 0-2.681.62l-2.438 3.392-13.263-7.115a2.085 2.085 0 0 0-2.68.62l-8.794 12.231-4.605-19.888a2.785 2.785 0 0 1 2.083-3.338l32.527-7.531a2.785 2.785 0 0 1 3.338 2.083l5.498 23.746-8.985-4.82Z"
            />
        </g>
        <path
            fill="#D9D9D9"
            d="M62.507 26.058 49.476 60.464l-.72.281L59.57 12.901l2.938 13.157Z"
            style={{mixBlendMode: 'multiply'}}
        />
        <rect
            width="57.453"
            height="57.453"
            x="67.698"
            y="11"
            fill="#F5F5F5"
            rx="6"
            transform="rotate(20.875 67.698 11)"
        />
        <g clipPath="url(#c)">
            <path
                fill="#33F"
                d="M97.103 44.77a3.13 3.13 0 1 0 2.23-5.85 3.13 3.13 0 0 0-2.23 5.85Z"
            />
            <path
                fill="url(#d)"
                d="M107.336 34.528 76.14 22.631a4.173 4.173 0 0 0-5.386 2.412L58.856 56.24a4.173 4.173 0 0 0 2.413 5.387l31.196 11.897a4.173 4.173 0 0 0 5.386-2.412l11.898-31.196a4.174 4.174 0 0 0-2.413-5.387ZM94.996 53.18a2.088 2.088 0 0 0-2.572-.98l-3.915 1.454-7.037-13.304a2.085 2.085 0 0 0-2.571-.98l-14.122 5.244 7.275-19.075a2.785 2.785 0 0 1 3.59-1.608l31.197 11.897a2.786 2.786 0 0 1 1.608 3.591l-8.686 22.775-4.767-9.014Z"
            />
        </g>
        <defs>
            <linearGradient
                id="b"
                x1="39.792"
                x2="30.379"
                y1="54.818"
                y2="14.159"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2C46E0" />
                <stop offset=".57" stopColor="#5D54FD" />
            </linearGradient>
            <linearGradient
                id="d"
                x1="76.867"
                x2="91.738"
                y1="67.575"
                y2="28.58"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2C46E0" />
                <stop offset=".57" stopColor="#5D54FD" />
            </linearGradient>
            <clipPath id="a">
                <path
                    fill="#fff"
                    d="m10.05 18.866 40.659-9.414 9.413 40.66-40.66 9.413z"
                />
            </clipPath>
            <clipPath id="c">
                <path
                    fill="#fff"
                    d="m72.24 21.144 38.996 14.872L96.364 75.01 57.37 60.139z"
                />
            </clipPath>
        </defs>
    </svg>
);

export default SvgFiles;
